
import { createSlice } from "@reduxjs/toolkit";

let initialConfigurableContents = {}
const configurableContentSlice = createSlice({
    name: 'configurableContents',
    initialState: initialConfigurableContents,
    reducers: {
        setConfigurableContents: (state, action) => {
            return {
                ...action.payload
            }
        },
        resetConfigurableContents: () => {
            return initialConfigurableContents
        }
    },
});

export const { setConfigurableContents, resetConfigurableContents } = configurableContentSlice.actions;
export default configurableContentSlice.reducer;